module.exports = __webpack_public_path__ + "static/media/right-chevron-lightblue.7ea1baec.svg";